import React from 'react';
import { type Theme, useStyletron } from 'baseui';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import type { StyleObject } from 'styletron-react';
import { ROW_EXPAND_STATE } from '../../../constants/frame-timeline-v4';
import type { AnnotationRowDescriptorT } from '../../../types/frame-timeline-v4';
import { getAnnotationLabelIcon } from '../../side-panel-m4/utils/get-annotation-label-icon';
import { ChevronSpacer } from './chevron-spacer';
import { ExpandChevron } from './expand-chevron';
import { getNameStyle } from './styles';
type PropsT = {
  descriptor: AnnotationRowDescriptorT;
  isSelected: boolean;
  onToggleExpand?: (rowId: string) => void;
  onSelect?: (rowId: string) => void;
};
const getSelectableStyle = (theme: Theme): StyleObject => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.sizing.scale200,
  flex: '1 1 auto',
  minWidth: 0,
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  textAlign: 'left'
});
export const AnnotationRowLabel = ({
  descriptor,
  isSelected,
  onToggleExpand,
  onSelect
}: PropsT) => {
  const [css, theme] = useStyletron();
  return <>
      {descriptor.expandState ? <ExpandChevron expanded={descriptor.expandState === ROW_EXPAND_STATE.EXPANDED} onToggle={() => onToggleExpand?.(descriptor.id)} /> : <ChevronSpacer />}
      <button type="button" data-testid="row-label-select" aria-pressed={isSelected} className={css(getSelectableStyle(theme))} onClick={() => onSelect?.(descriptor.id)}>
        <span className={css({
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0
      })}>
          {getAnnotationLabelIcon(descriptor.label)}
        </span>
        <StatefulTooltip content={descriptor.name} placement={PLACEMENT.top}>
          <span className={css(getNameStyle(theme))}>{descriptor.name}</span>
        </StatefulTooltip>
      </button>
    </>;
};